import type { DirectoryCreateSchema } from '@repo/schemas/directory/directoryCreate';
import type { DirectoryPrivate } from '@repo/types/directory';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DirectoryService } from './directoryService';
import { DirectoryKey } from './keys';

export function usePostDirectory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: DirectoryCreateSchema) => DirectoryService.createDirectory(data).then((response) => response.data),
    onSuccess: (data, variables) => {
      queryClient.setQueryData<DirectoryPrivate>([DirectoryKey.DIRECTORY, variables.parentDirId], (prev) => {
        if (!prev) {
          return;
        }
        return {
          ...prev,
          childDirs: [...prev.childDirs, data],
        };
      });
    },
    onSettled: (_data, _error, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [DirectoryKey.DIRECTORY, variables.parentDirId],
      });
    },
  });
}
